//open drawer when we click "back" in checkout
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (typeof urlParams.get('open-cart-drawer') != "undefined" && urlParams.get('open-cart-drawer') != null && urlParams.get('open-cart-drawer') == 'true') {
    let button = document.getElementById('cart-drawer-toggle');
    button?.click();

    history.pushState(null, "", location.href.split("?")[0]);

    document.querySelectorAll('a').forEach(function (el) {
      let href = el.getAttribute('href');
      if (href && href.includes('?open-cart-drawer=true')) {
        el.setAttribute('href', href.replace('?open-cart-drawer=true', ''));
      }
    });
  }
});

// Back to top button functionality
document.addEventListener("DOMContentLoaded", () => {
  let button = document.querySelector('[href="#subscribe"]');

  button?.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#main-content').scrollIntoView({ behavior: 'smooth' });
  });

});

// Lazy load iframes on mobile devices
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) { // Mobile-only
    const lazyIframes = document.querySelectorAll('iframe[data-src]');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          iframe.src = iframe.dataset.src;
          iframe.removeAttribute('data-src');
          obs.unobserve(iframe);
        }
      });
    }, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.1
    });

    lazyIframes.forEach(iframe => observer.observe(iframe));
  }
});